import { render, staticRenderFns } from "./CreateObjectWizard.vue?vue&type=template&id=5a4e629d&scoped=true&"
import script from "./CreateObjectWizard.vue?vue&type=script&lang=js&"
export * from "./CreateObjectWizard.vue?vue&type=script&lang=js&"
import style0 from "./CreateObjectWizard.vue?vue&type=style&index=0&id=5a4e629d&scoped=true&lang=css&"
import style1 from "./CreateObjectWizard.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a4e629d",
  null
  
)

export default component.exports